{
  "cta": {
    "create-a-chart": "Opret en tabel"
  },
  "breadcrumb": {
    "dashboard": "Dashboard",
    "products": "Produkter",
    "charts": "Tabeller",
    "restock-alerts": "Genopfyldningsadvarsler",
    "settings": "Indstillinger",
    "setting": "Indstillinger",
    "account": "Konto",
    "personal": "Personlig",
    "organization": "Organisation",
    "appearance": "Udseende",
    "themes": "Temaer",
    "button": "Knap",
    "font-family": "Skrifttypefamilie",
    "uploads": "Uploads",
    "dimensions": "Dimensioner",
    "notifications": "Notifikationer",
    "analytic": "Analyse",
    "analytics": "Analyse",
    "restock-settings": "Genopfyldningsindstillinger",
    "inventory": "Genopfyldningsadvarsler",
    "plans": "Planer",
    "billing": "Fakturering",
    "overview": "Oversigt",
    "plan-and-usage": "Plan og forbrug",
    "chart-views": "Tabelvisninger",
    "add-to-cart": "Læg i kurv",
    "buy-now": "Køb nu",
    "size-recommendations": "Størrelsesanbefalinger",
    "stock-notifications": "Lagernotifikationer",
    "reports": "Rapporter",
    "comparison": "Sammenligning",
    "images": "Uploads",
    "sidekick": "Sidekick",
    "import": "Import",
    "contact": "Kontakt",
    "help-articles": "Hjælpeartikler",
    "new": "Ny"
  },
  "page": {
    "dashboard": {
      "table-style-chart": "Tabel i gitterstil",
      "build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions": "Byg et fuldt tilpasset gitter med fuld kontrol over hver række, kolonne og måleenhed. Bedst til komplekse størrelser på tværs af flere regioner.",
      "create-table-chart": "Opret gittertabel",
      "create-from-product": "Opret fra produkt",
      "start-from-template": "Start fra skabelon",
      "browse-templates": "Gennemse skabeloner",
      "create-with-drag-drop": "Opret med træk og slip",
      "creating": "Opretter",
      "how-would-you-like-to-build-your-chart": "Hvordan vil du gerne<br /><span class=\"text-primary\">bygge din størrelsestabel?</span>",
      "choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit": "Vælg en metode nedenfor, eller fortæl os hvad du sælger, og vi fremhæver det bedste valg.",
      "fastest-setup-2-min": "Hurtigste opsætning · ~2 min",
      "used-by-1000-merchants": "Bruges af 1000+ forhandlere",
      "auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you": "Generér automatisk en matchende størrelsestabel direkte fra dine eksisterende Shopify-variantdata. Ingen manuel indtastning — den læser dit produkt og udfylder tabellen for dig",
      "garment-templates-ready-to-use": "Klar-til-brug beklædningsskabeloner",
      "pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute": "Vælg mellem færdige skabeloner til overdele, underdele, sko, bælter, tasker og mere. Tilpas ethvert felt bagefter — perfekt til at komme i gang på under et minut.",
      "drag-drop-no-data-needed-upfront": "Træk og slip · ingen data nødvendige på forhånd",
      "upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment": "Upload et hvilket som helst produktbillede og markér mål direkte på det med træk-og-slip-punkter. Ideel til sko, tasker, tilbehør og udstyr.",
      "excel-like": "Excel-lignende",
      "auto-generated": "Automatisk genereret",
      "annotate-on-image": "Markér på billede",
      "what-are-you-selling": "Hvad sælger du?",
      "category-clothing-apparel": "Tøj og beklædning",
      "category-shoes": "Sko",
      "category-accessories": "Tilbehør",
      "category-other": "Noget andet",
      "start-date": "Startdato",
      "end-date": "Slutdato"
    },
    "products": {
      "select-a-product-to-create-or-link-a-size-chart-for-that-product": "Vælg et produkt for at oprette eller knytte en størrelsestabel til det produkt.",
      "product-name": "Produktnavn",
      "best-selling": "Bedst sælgende",
      "most-selling": "Mest solgte først",
      "least-selling": "Mindst solgte",
      "best-selling-unavailable": "Salgsdata er endnu ikke tilgængelige, så produkterne vises efter seneste opdatering.",
      "chart-attached": "Tabel tilknyttet",
      "shopify-status": "Shopify-status",
      "search-placeholder": "Søg i alle produkter...",
      "vendors": "Leverandører",
      "tags": "Tags",
      "statuses": "Statusser",
      "collections": "Kollektioner",
      "types": "Typer",
      "add-filter": "Tilføj filter",
      "categories": "Kategorier",
      "search-and-filter-tooltip": "Søg og filtrer (F)",
      "import-selection": "Importér valg",
      "failed-import-measurements": "Kunne ikke importere mål",
      "product-updated": "Produkt opdateret"
    },
    "charts": {
      "create-edit-duplicate-or-link-a-chart-to-a-product-from-here": "Opret, redigér, dupliker eller knyt en tabel til et produkt herfra.",
      "chart-name": "Tabelnavn",
      "chart-type": "Tabeltype",
      "linked-to": "Knyttet til",
      "last-updated": "Sidst opdateret",
      "delete-x-charts": "Slet {{ x }} tabeller",
      "assigned-products": "Tildelte produkter",
      "failed-to-fetch-products-data": "Kunne ikke hente produktdata",
      "delete-chart": "Slet tabel",
      "are-you-sure-you-want-to-delete-selected-chart-s-all-products-using-chart-s-will-be-unassigned": "Er du sikker på, at du vil slette den (de) valgte tabel(ler)? Alle produkter, der bruger tabellen(erne), vil blive frigjort.",
      "successfully-deleted-chart-s": "Tabel(ler) blev slettet!",
      "successfully-duplicated-chart": "Tabel blev dupliceret!",
      "turn-this-into-a-conversion-chart": "Gør dette til en konverteringstabel",
      "upgradable-tooltip": "Denne gittertabel ligner en struktureret størrelsestabel og kan konverteres.",
      "convert-to-size-chart": "Konvertér til størrelsestabel",
      "convertibility-failed": "Vi kunne ikke tjekke, hvilke gittertabeller der kan konverteres.",
      "convert": {
        "table-chart-info-callout": "Denne gittertabel kan opgraderes til en smart størrelsestabel",
        "table-chart-info-callout-message": "Konvertering knytter dit gitter til dimensioner fra dit bibliotek, hvilket låser op for en visuel målevejledning og modelinformation, som en almindelig tabel ikke kan vise.",
        "successfully-converted": "Konverteret til størrelsestabel!",
        "detected-sizes": "Registrerede størrelser",
        "at-least-two-sizes-are-needed": "Der kræves mindst to størrelser for at konvertere denne tabel.",
        "unnamed-row": "Unavngiven række",
        "ignore-this-row": "Ignorér denne række",
        "this-dimension-is-already-mapped": "Denne dimension er allerede tilknyttet en anden række.",
        "map-at-least-one-row": "Tilknyt mindst én række til en dimension.",
        "finish-your-measurement-guide": "Fuldfør din målevejledning",
        "measurement-points-without-values": "Målepunkter uden værdier ({{ x }})",
        "fill-them-in-after-converting": "Dit valgte billede viser dem, men din tabel havde ingen sådanne rækker. Udfyld deres værdier efter konvertering.",
        "measurements-without-points": "Mål uden et punkt på dit billede ({{ x }})",
        "no-image-selected-yet": "Intet billede valgt endnu",
        "upload-an-image-then-drag-points": "Upload et billede, og træk derefter målepunkterne over på det.",
        "your-image-has-no-measurement-points": "Dit valgte billede har endnu ingen målepunkter",
        "drag-measurement-points-onto-the-image": "Træk deres målepunkter over på billedet, så kunderne kan se, hvor de skal måle.",
        "plus-x-more": "+{{ x }} mere",
        "satisfied-button": "Ser godt ud — gør dette til min aktive tabel",
        "satisfied-explanation": "Din gittertabel bliver afpubliceret, denne tabel bliver publiceret, og dens tildelte produkter flyttes over.",
        "satisfied-success": "Denne tabel er nu aktiv!",
        "step-x-of-y": "Trin {{ x }} af {{ y }}",
        "choose-product-type": "Vælg produkttype",
        "well-match-your-table-to-a-visual": "Vi matcher din tabel med det rigtige visuelle produkt.",
        "save-settings": "Gem indstillinger",
        "review-table-mapping": "Gennemgå tabelmapping",
        "confirm-the-rows-to-convert": "Bekræft de rækker, vi skal konvertere.",
        "existing-table": "Eksisterende tabel",
        "sizes": "Størrelser",
        "row": "Række",
        "column": "Kolonne",
        "x-rows-need-review": "{{ x }} rækker kræver gennemgang",
        "couldnt-match-this-row": "Vi kunne ikke matche dette mål automatisk",
        "change-match": "Skift match",
        "view-values": "Vis værdier",
        "hide-values": "Skjul værdier",
        "matched-automatically": "Matchet automatisk",
        "edit-matches": "Redigér matches",
        "create-preview": "Opret forhåndsvisning",
        "preview-ready": "Forhåndsvisning klar",
        "open-it-to-finish-the-missing-values": "Åbn den for at udfylde de manglende værdier.",
        "converted": "Konverteret",
        "open-preview": "Åbn forhåndsvisning",
        "you-can-add-them-in-the-preview": "Du kan tilføje dem i forhåndsvisningen."
      }
    },
    "inventory": {
      "collect-emails-and-send-automatic-back-in-stock-notifications-setup-notification": "Indsaml e-mails og send automatiske genopfyldningsnotifikationer. Opsæt notifikation",
      "here": "her",
      "successfully-export-inventory-data": "Lagerdata blev eksporteret",
      "active-your-store-inventory-notification-feature": "Aktivér din butiks lagernotifikationsfunktion",
      "in-order-to-receive-users-subscribed-for-your-products": "for at modtage brugere, der abonnerer på dine produkter.",
      "your-subscribers-have-been-delegeted-to-your": "Dine abonnenter er blevet overført til din"
    },
    "setting": {
      "storefront-popup-preview": "Forhåndsvisning af pop-up i webshoppen",
      "add-to-cart": "Læg i kurv",
      "buy-now": "Køb nu",
      "sans-serif": "Sans serif",
      "serif": "Serif",
      "email-body-is-required": "E-mail-tekst er påkrævet",
      "list": "Liste",
      "category-image": "Kategoribillede",
      "pay-over-usage-cost": "Betal overforbrugsomkostning",
      "over-usage-count": "Antal overforbrug",
      "over-usage-cost": "Overforbrugsomkostning",
      "x-usages": "{{ x }} anvendelser",
      "failed-to-pay-over-usage-cost": "Kunne ikke betale overforbrugsomkostning",
      "manage-your-personal-information-and-account-perferences": "Administrér dine personlige oplysninger og kontopræferencer.",
      "manage-your-organization-contact-information-and-address": "Administrér din organisations kontaktoplysninger og adresse.",
      "manage-your-billing-overview": "Gennemgå dine faktureringsoplysninger, plan og betalingsoplysninger.",
      "manage-your-plan-and-usage": "Se din nuværende plan og forbrugsgrænser.",
      "manage-your-measurement-dimensions": "Administrér de måledimensioner, der bruges på tværs af dine størrelsestabeller.",
      "dimension-translations": "Oversættelser til webshop",
      "dimension-translations-description": "Indtast den etiket, kunder skal se for hvert understøttet webshop-sprog. Lad stå tomt for at bruge standardnavnet.",
      "default-dimension-name": "Standard dimensionsnavn",
      "dimension-name-description": "Bruges i hele dashboardet og som webshop-reserve, når ingen oversættelse er angivet.",
      "storefront-label": "Etiket til webshop",
      "naming": "Navngivning",
      "affecting-data": "Berørte data",
      "first-name-is-required": "Fornavn er påkrævet",
      "last-name-is-required": "Efternavn er påkrævet",
      "subscribed-for-our-latest-news-exclusive-offers-and-exciting-updates": "Tilmeldt vores seneste nyheder, eksklusive tilbud og spændende opdateringer.",
      "contact-information": "Kontaktoplysninger",
      "contact-name": "Kontaktnavn",
      "contact-name-is-required": "Kontaktnavn er påkrævet!",
      "contact-email": "Kontakt-e-mail",
      "contact-email-is-required": "Kontakt-e-mail er påkrævet!",
      "contact-email-is-invalid": "Kontakt-e-mail er ugyldig!",
      "company-organization-name": "Firma-/organisationsnavn",
      "company-organization-name-is-required": "Firma-/organisationsnavn er påkrævet",
      "street-address": "Gadeadresse",
      "street-address-is-required": "Gadeadresse er påkrævet!",
      "street-address-2": "Gadeadresse 2",
      "city": "By",
      "city-is-required": "By er påkrævet!",
      "state-province-region": "Stat/Provins/Region",
      "state-province-region-is-required": "Stat/Provins/Region er påkrævet!",
      "country": "Land",
      "country-is-required": "Land er påkrævet!",
      "postal-zip-code": "Postnummer",
      "postal-zip-code-is-required": "Postnummer er påkrævet!",
      "themes": "Temaer",
      "customise-your-app-look-choose-a-colour-that-best-represents-your-brand": "Tilpas din apps udseende! Vælg en farve, der bedst repræsenterer dit brand",
      "sunset-ember": "Solnedgangsglød",
      "classic-noir": "Klassisk sort",
      "system-background-colour": "Systembaggrundsfarve",
      "customise-your-button": "Tilpas din knap",
      "customise-your-button-text-colour-and-style-to-match-your-brand": "Tilpas din knaps tekst, farve og stil, så den matcher dit brand.",
      "what-should-the-button-say": "Hvad skal knappen sige?",
      "label-button-is-required": "Knapetiket er påkrævet!",
      "text-colour": "Tekstfarve",
      "text-colour-is-required": "Tekstfarve er påkrævet!",
      "please-input-valid-hex-color-code": "Indtast en gyldig hex-farvekode",
      "background-color": "Baggrundsfarve",
      "background-colour-is-required": "Baggrundsfarve er påkrævet!",
      "font-size-in-px": "Skriftstørrelse i px",
      "font-size-in-px-is-required": "Skriftstørrelse i px er påkrævet!",
      "border-radius": "Kantradius",
      "border-radius-is-required": "Kantradius er påkrævet!",
      "successfully-updated-button-style": "Knapstil blev opdateret",
      "font-family": "Skrifttypefamilie",
      "customise-your-font": "Tilpas din skrifttype",
      "match-your-store-look-and-feel-by-updating-the-font-across-your-size-charts": "Match din butiks udseende og fornemmelse ved at opdatere skrifttypen på tværs af dine størrelsestabeller.",
      "select-a-font-from-the-list-bellow": "Vælg en skrifttype fra listen nedenfor.",
      "search-font": "Søg efter skrifttype...",
      "fetching-fonts": "Henter skrifttyper...",
      "showing-x-fonts": "Viser {{ x }} skrifttyper",
      "sort-by-x": "Sortér efter {{ x }}",
      "most-popular": "Mest populære",
      "here-how-it-will-look-on-your-shop": "Sådan vil det se ud i din butik",
      "it-ll-updated-across-all-your-chart-displays": "Det opdateres på tværs af alle dine tabelvisninger.",
      "update-font-across-all-size-charts": "Opdatér skrifttype på alle størrelsestabeller",
      "choose-a-font-to-match-your-store-style": "Vælg en skrifttype, der matcher din butiks stil",
      "apply-font": "Anvend skrifttype",
      "font-applied-successfully": "Skrifttype anvendt!",
      "manage-and-delete-your-uploaded-images-removing-a-file-is-permanent-and-cannot-be-undone": "Administrér og slet dine uploadede billeder. Fjernelse af en fil er permanent og kan ikke fortrydes.",
      "do-you-want-to-delete-image": "Vil du slette billedet?",
      "image-deleted-successfully": "Billede slettet",
      "chart-list": "Tabelliste",
      "delete-x-dimensions": "Slet {{ x }} dimensioner",
      "view-affecting-data": "Vis berørte data",
      "no-data-will-be-affected": "Ingen data vil blive berørt.",
      "do-you-want-to-delete-selected-dimensions": "Vil du slette de valgte dimensioner?",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-annotation-and-data-removed": "Alle annotationssæt og tabeller, der i øjeblikket bruger disse dimensioner, får deres annotation og data fjernet",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-name-changed": "Alle annotationssæt og tabeller, der i øjeblikket bruger disse dimensioner, får deres navn ændret",
      "delete-dimension": "Slet dimension",
      "successfully-deleted-dimension": "Dimension(er) blev slettet!",
      "successfully-update-dimension": "Dimension blev opdateret!",
      "configure-how-back-in-stock-notifications-work-for-your-customers": "Konfigurér, hvordan genopfyldningsnotifikationer fungerer for dine kunder",
      "activate-back-in-stock-notifications": "Aktivér genopfyldningsnotifikationer",
      "allow-shoppers-to-subscribe-for-alerts-when-a-size-or-product-is-sold-out-notifications-will-be-sent-automatically-once-stock-is-available": "Giv kunder mulighed for at abonnere på advarsler, når en størrelse eller et produkt er udsolgt. Notifikationer sendes automatisk, når varen er på lager igen.",
      "notification-channels": "Notifikationskanaler",
      "third-party-service": "Tredjepartstjeneste",
      "sms": "SMS",
      "coming-soon": "Kommer snart",
      "signup-experience-design": "Design af tilmeldingsoplevelse",
      "form-display": "Formularvisning",
      "modal-popup": "Modal pop-up",
      "email-template-customisation": "Tilpasning af e-mail-skabelon",
      "subject-line": "Emnelinje",
      "subject-line-is-required": "Emnelinje er påkrævet",
      "your-size-is-back-in-stock": "Din størrelse er tilbage på lager 🎉",
      "email-body": "E-mail-tekst",
      "inventory-threshold-setting": "Indstilling af lagertærskel",
      "notify-shoppers-when-inventory-reaches-at-least": "Giv kunder besked, når lageret når mindst",
      "threshold-is-required": "Tærskel er påkrævet",
      "threshold-must-be-greater-than-0": "Tærskel skal være større end 0",
      "units": "enheder",
      "set-the-minimum-inventory-level-required-to-trigger-notifications": "Angiv det minimale lagerniveau, der kræves for at udløse notifikationer",
      "choose-a-service": "Vælg en tjeneste",
      "signing-out": "Logger ud",
      "signout-of": "Log ud af",
      "authenticate": "Godkend",
      "save-settings": "Gem indstillinger",
      "hi-your-is-now-back-in-stock-get-it-before-it-gone": "Hej {{first_name}}, din {{product_name}} ({{size_variant}}) er nu tilbage på lager. Få den, før den er væk igen!",
      "successfully-updated-notification-back-in-stock": "Genopfyldningsnotifikation blev opdateret",
      "preferred-language": "Foretrukket sprog",
      "successfully-updated-your-profile": "Din profil blev opdateret",
      "successfully-updated-mailing-subscription-status": "Nyhedsbrevsstatus blev opdateret!",
      "upgrade-plan": "Opgradér plan",
      "overview": "Oversigt",
      "billing-cycle": "Faktureringscyklus",
      "billing-cycle-resets-at-midnight-on-x-and-the-next-charge-is-on-y": "Faktureringscyklussen nulstilles ved midnat den {{ x }}, og den næste betaling er den {{ y }}",
      "billing-information": "Faktureringsoplysninger",
      "update-billing": "Opdatér fakturering",
      "monthly-total": "Månedlig total",
      "free-trial-x-days-left": "Gratis prøveperiode - {{ x }} dage tilbage",
      "cancel-plan": "Annullér plan",
      "change-plan": "Skift plan",
      "plan-and-usage": "Plan og forbrug",
      "tier-offers-in-use": "Niveautilbud i brug",
      "failed-to-cancel-plan": "Kunne ikke annullere plan",
      "total-usage": "Samlet forbrug",
      "current-usage-summary": "Aktuel forbrugsoversigt",
      "published-charts": "Offentliggjorte tabeller",
      "limit-reached": "grænsen er nået",
      "plan-details": "Plandetaljer",
      "current-plan": "Nuværende plan",
      "select-a-reason": "Vælg en årsag",
      "please-provide-your-reason": "Angiv venligst din årsag",
      "chart-preferences": "Tabelpræferencer",
      "skip-picking-dimensions-when-creating-a-new-chart-from-template": "Spring valg af dimensioner over, når der oprettes en ny tabel fra skabelon",
      "border-color": "Kantfarve",
      "border-color-is-required": "Kantfarve er påkrævet!",
      "list-of-charts-using-this-image": "Liste over tabeller, der bruger dette billede",
      "successfully-update-your-profile": "Din profil blev opdateret"
    },
    "analytic": {
      "failed-to-load-statistics": "Kunne ikke indlæse statistik",
      "total-chart-views": "Tabelvisninger",
      "total-add-to-cart": "Lagt i kurv",
      "traffic-by-location": "Trafik efter placering",
      "desktop": "Computer",
      "mobile": "Mobil",
      "size-recommendations": {
        "failed-to-load": "Kunne ikke indlæse analyse af størrelsesanbefalinger",
        "total-suggestions-title": "Givne forslag",
        "conversion-title": "Konvertering",
        "customers-proceeded": "Kunder fortsatte med forslaget",
        "of-x-suggestions": "af {{count}} forslag",
        "most-suggested-title": "Mest foreslåede produkt og variant",
        "suggestions-count": "{{count}} forslag",
        "most-common-profile-title": "Mest almindelige profil",
        "average-profile-title": "Gennemsnitlig profil",
        "gender": "Køn",
        "age-group": "Aldersgruppe",
        "height": "Højde",
        "weight": "Vægt",
        "size-recommended": "Anbefalet størrelse",
        "graph-suggestions": "Forslag",
        "graph-proceed": "Fortsæt",
        "source-all": "Alle",
        "source-chart": "Størrelsestabel",
        "source-table-chart": "Gittertabel"
      },
      "chart-views": {
        "failed-to-load": "Kunne ikke indlæse tabelvisninger",
        "device-types": "Enhedstyper",
        "most-viewed-chart": "Mest viste tabel",
        "most-viewed-product": "Mest viste produkt",
        "views-count": "{{ count }} visninger",
        "view-at": "Vist den",
        "location": "Placering",
        "graph-label": "Visninger"
      },
      "add-to-cart": {
        "failed-to-load": "Kunne ikke indlæse analyse af læg i kurv",
        "estimated-revenue": "Estimeret påvirket værdi",
        "conversion-title": "Konvertering fra visning af tabel → læg i kurv",
        "most": "Flest lagt i kurv",
        "adds-count": "{{count}} lagt i kurv",
        "added-at": "Tilføjet den",
        "graph-label": "Lagt i kurv",
        "views-dataset-label": "Visninger",
        "add-to-cart-dataset-label": "Læg i kurv"
      },
      "stock-notifications": {
        "failed-to-load": "Kunne ikke indlæse analyse af lagernotifikationer",
        "failed-to-load-table": "Kunne ikke indlæse tabel over lagernotifikationer",
        "total-subscriptions": "Abonnementer",
        "total-notifications-sent": "Sendte notifikationer",
        "delivery-rate": "Leveringsrate",
        "opened-of-notified": "{{ opened }} åbnet / {{ notified }} underrettet",
        "most-subscribed": "Flest abonnenter",
        "subscriptions-count": "{{ count }} abonnementer",
        "latest-subscribed": "Seneste abonnement",
        "subscribed-at": "Abonneret: {{ date }}",
        "longest-waiting": "Længste ventetid på genopfyldning",
        "waiting-days": "Venter: {{ days }} dage",
        "waiting-since": "(siden {{ date }})",
        "subscriptions": "Abonnementer",
        "notifications-sent": "Sendte notifikationer",
        "opened": "Åbnet",
        "at": "Den",
        "graph-label": "Abonnementer"
      },
      "paid-gate": {
        "unlock-message": "Lås op for avanceret analyse for at se fulde data og træffe bedre beslutninger.",
        "upgrade": "Opgradér",
        "failed-to-fetch-plans": "Kunne ikke hente planer"
      },
      "buy-now": {
        "failed-to-load": "Kunne ikke indlæse analyse af køb nu",
        "total": "Køb nu",
        "estimated-revenue": "Estimeret påvirket værdi",
        "conversion-title": "Konvertering fra visning af tabel → køb nu",
        "most": "Mest købte produkt via Køb nu",
        "buys-count": "{{count}} køb nu",
        "graph-label": "Køb nu",
        "views-dataset-label": "Visninger",
        "buy-now-dataset-label": "Køb nu",
        "clicked-at": "Klikket den"
      },
      "overview": {
        "funnel-title": "Hvad visningerne af størrelsesguiden førte til",
        "no-views-title": "Ingen visninger af guiden i denne periode",
        "no-views-hint": "Størrelsesguider vises på produktsider, når de er udgivet og tilknyttet produkter.",
        "chart-views-caption": "Kunder der åbnede en størrelsesguide",
        "baseline-caption": "Alt nedenfor måles op mod disse visninger",
        "of-views": "af {{ count }} visninger",
        "not-in-funnel": "Ikke en del af guidens tragt"
      },
      "preview": {
        "title": "Ingen data endnu — dette er en forhåndsvisning",
        "message": "Tallene nedenfor er eksempeldata, der viser, hvordan denne side kommer til at se ud, når kunderne begynder at bruge dine størrelsesguider."
      }
    },
    "plans": {
      "popular-plan": "Populær plan",
      "try-now": "Prøv nu",
      "activated": "Aktiveret",
      "contact-sales": "Kontakt salg",
      "try-free-for-1-month": "Prøv gratis i 1 måned",
      "activate": "Aktivér",
      "what-included": "Hvad er inkluderet?",
      "choose-the-plan-that-fits-your-business-needs": "Vælg den plan, der passer til dine forretningsbehov",
      "whether-youre-just-starting-out-or-looking-for-a-robust-sizing-solution-weve-got-a-plan-thats-right-for-you": "Uanset om du lige er startet, eller du søger en robust størrelsesløsning, har vi en plan, der passer til dig.",
      "monthly": "Månedligt",
      "annually": "Årligt",
      "compare-plan-features": "Sammenlign planfunktioner",
      "compare-all-plan-features": "Sammenlign alle planfunktioner",
      "feature-usages": "Forbrug",
      "feature-analytics": "Analyser",
      "feature-support": "Support",
      "feature-integration": "Integration",
      "feature-branding": "Branding",
      "feature-api-access": "API-adgang",
      "feature-stock-notifications": "Lagernotifikationer",
      "feature-published-conversion-charts": "Offentliggjorte konverteringstabeller",
      "feature-advanced-variant-mapping": "Avanceret variantmapping",
      "failed-to-fetch-plans": "Kunne ikke hente planer",
      "failed-to-activate-plan": "Kunne ikke aktivere plan",
      "contact": {
        "title": "Kontakt salg",
        "subtitle": "Fortæl os om din butik og hvad du har brug for. Vores team vender tilbage til dig via e-mail.",
        "message-placeholder": "Hvordan kan vi hjælpe din virksomhed?",
        "send": "Send besked",
        "success": "Tak! Din besked er sendt. Vores team kontakter dig snarest.",
        "first-name-required": "Fornavn er påkrævet",
        "last-name-required": "Efternavn er påkrævet",
        "email-required": "E-mail er påkrævet",
        "email-invalid": "E-mail er ugyldig",
        "message-required": "Besked er påkrævet"
      },
      "invite": {
        "title": "Gennemfør dit abonnement",
        "your-plan": "Dit abonnement",
        "order-summary": "Ordreoversigt",
        "billed-every-30-days": "Faktureres hver 30. dag",
        "billed-yearly": "Faktureres årligt",
        "free-trial": "{{days}} dages gratis prøveperiode",
        "due-today": "Skal betales i dag",
        "then-every-30-days": "Derefter {{price}} USD hver 30. dag",
        "then-yearly": "Derefter {{price}} USD om året",
        "continue": "Fortsæt til godkendelse",
        "shopify-note": "Faktureres via Shopify. Du godkender betalingen på næste skærm.",
        "switching-note": "Dette erstatter dit nuværende abonnement, når du godkender. Shopify modregner den resterende tid.",
        "already-on-plan": "Du har allerede dette abonnement",
        "unavailable-title": "Denne invitation er ikke længere tilgængelig",
        "unavailable-body": "Linket er muligvis udløbet. Kontakt den person, der sendte det, eller se de abonnementer, der er åbne for alle butikker.",
        "see-plans": "Se abonnementer",
        "failed-title": "Dette abonnement kunne ikke indlæses",
        "failed-body": "Tjek din forbindelse, og genindlæs siden."
      }
    },
    "auth": {
      "signin": {
        "please-sign-in": "Log venligst ind",
        "email-is-required": "E-mail er påkrævet",
        "invalid-email-address": "Ugyldig e-mailadresse",
        "password-is-required": "Adgangskode er påkrævet",
        "sign-in": "Log ind",
        "reset-password": "Nulstil adgangskode",
        "generic-error": "Der opstod en fejl! Prøv venligst igen senere."
      }
    },
    "admin": {
      "reports": {
        "title": "Rapporter",
        "chart-views": {
          "title": "Tabelvisninger",
          "description": "Se, hvor mange gange kunder åbnede størrelsestabellen, globalt på tværs af alle butikker.",
          "failed-to-load": "Kunne ikke indlæse rapport om tabelvisninger",
          "total-views": "Tabelvisninger",
          "most-viewed-chart": "Mest viste tabel",
          "most-viewed-product": "Mest viste produkt",
          "views-count": "{{ count }} visninger",
          "traffic-by-location": "Trafik efter placering",
          "device-types": "Enhedstyper",
          "desktop": "Computer",
          "mobile": "Mobil",
          "top-stores": "Bedste butikker",
          "no-top-stores": "Ingen butiksdata endnu",
          "graph-label": "Visninger",
          "view-at": "Vist den",
          "location": "Placering"
        },
        "add-to-cart": {
          "title": "Læg i kurv",
          "description": "Se, hvordan størrelsestabellen påvirker begivenheder for læg-i-kurv, globalt på tværs af alle butikker.",
          "failed-to-load": "Kunne ikke indlæse rapport om læg i kurv",
          "total-add-to-cart": "Lagt i kurv",
          "conversion-title": "Konvertering fra visning af tabel → læg i kurv",
          "most": "Flest lagt i kurv",
          "adds-count": "{{ count }} lagt i kurv",
          "top-stores": "Bedste butikker",
          "no-top-stores": "Ingen butiksdata endnu",
          "graph-label": "Lagt i kurv",
          "views-dataset-label": "Visninger",
          "add-to-cart-dataset-label": "Læg i kurv",
          "added-at": "Tilføjet den"
        },
        "buy-now": {
          "title": "Køb nu",
          "description": "Se, hvordan størrelsestabellen påvirker køb-nu-begivenheder, globalt på tværs af alle butikker.",
          "failed-to-load": "Kunne ikke indlæse rapport om køb nu",
          "total-buy-now": "Køb nu",
          "conversion-title": "Konvertering fra visning af tabel → køb nu",
          "most": "Mest købte produkt via Køb nu",
          "buys-count": "{{ count }} køb nu",
          "top-stores": "Bedste butikker",
          "no-top-stores": "Ingen butiksdata endnu",
          "graph-label": "Køb nu",
          "views-dataset-label": "Visninger",
          "buy-now-dataset-label": "Køb nu",
          "clicked-at": "Klikket den"
        },
        "conversion-funnel": {
          "title": "Gittertabelkonvertering",
          "description": "Se, hvor forhandlere giver op, når de omdanner en gittertabel til en størrelsestabel, globalt på tværs af alle butikker.",
          "failed-to-load": "Kunne ikke indlæse rapport om gittertabelkonvertering",
          "total-runs": "Startede konverteringer",
          "runs-breakdown": "{{ converted }} konverteret · {{ handedOver }} overdraget",
          "conversion-title": "Startet → Konverteret",
          "handover-rate": "{{ rate }}% fortsatte med at overdrage deres produkter",
          "handover-gap-title": "Konverteret, ikke overdraget",
          "of-converted-runs": "af konverterede forsøg",
          "handover-gap-description": "En overdragelse kan ske dage senere, så nogle af disse afventer stadig snarere end at være opgivet.",
          "funnel-title": "Konverteringstragt",
          "funnel-note": "Det dedikerede overdragelsestrin udløses ikke længere — banneret er nu måden, overdragelser gennemføres på, så læs dets antal som det samlede antal overdragelser snarere end en trinkonvertering.",
          "no-funnel": "Ingen konverteringsforsøg i dette interval",
          "drop-off": "frafald",
          "runs-dataset-label": "Forsøg",
          "drop-offs-title": "Hvor forsøg slutter",
          "drop-offs-description": "Det sidste, hvert forsøg gjorde. Forsøg, der ender med en gennemført overdragelse — nu registreret via banneret — blev afsluttet med succes.",
          "no-drop-offs": "Ingen konverteringsforsøg i dette interval",
          "dwell-title": "Tid før afbrydelse",
          "dwell-description": "Registreres kun, når en forhandler opgiver et trin, plus tiden brugt på at læse gennemgangen før bekræftelse.",
          "no-dwell": "Ingen tidsdata i dette interval",
          "step": "Trin",
          "samples": "Stikprøver",
          "median": "Median",
          "p90": "P90",
          "top-stores": "Bedste butikker",
          "no-top-stores": "Ingen butiksdata endnu",
          "graph-label": "Startede konverteringer",
          "started-at": "Startet den",
          "duration": "Varighed",
          "last-step": "Sidste trin",
          "outcome": "Resultat",
          "steps": {
            "entry": "Dialog åbnet",
            "category": "Kategori",
            "mapping": "Mapping",
            "summary": "Gennemgang",
            "convert": "Konvertér",
            "handover": "Overdragelse",
            "banner": "Banner"
          },
          "actions": {
            "viewed": "vist",
            "completed": "gennemført",
            "skipped": "sprunget over",
            "back": "gik tilbage",
            "abandoned": "opgivet",
            "failed": "mislykkedes",
            "customize_clicked": "klikkede på tilpas",
            "dismissed": "afvist"
          },
          "outcomes": {
            "handed-over": "Overdraget",
            "converted": "Kun konverteret",
            "failed": "Mislykkedes",
            "abandoned": "Opgivet",
            "in-progress": "I gang"
          }
        }
      },
      "delete-category": "Slet kategori",
      "do-you-want-to-delete-selected-categories": "Vil du slette de valgte kategorier?",
      "global-categories-are-shared-by-every-store": "Globale kategorier deles af alle butikker — sletning af én påvirker dem alle. Dette kan ikke fortrydes.",
      "successfully-deleted-category": "Kategori slettet",
      "average-cost-per-recommendation": "Gennemsnitlig omkostning pr. anbefaling",
      "failed-to-load-recommendations-average-cost": "Kunne ikke indlæse gennemsnitlig omkostning for anbefalinger",
      "most-expensive-extract": "Dyreste udtræk",
      "most-expensive-recommendation": "Dyreste anbefaling",
      "total-recommendation-cost": "Samlet omkostning for anbefalinger",
      "total-size-recommendation": "Størrelsesanbefalinger",
      "total-sheet-extract": "Arkudtræk",
      "new-category": "Ny kategori",
      "category-created-unlisted-hint": "Kategorien er oprettet ikke-offentlig. Tilføj et billede og mål, før den offentliggøres til butikker.",
      "category-created-successfully": "Kategori oprettet!",
      "category-search-placeholder": "Billednavn, butiksnavn...",
      "dimension-search-placeholder": "Dimensionsnavn, butiksnavn...",
      "category-not-found": "Kategori ikke fundet",
      "sub-categories-variants": "Underkategorier/varianter:",
      "add-sub-category-variant": "Tilføj underkategori/variant:",
      "from-existing": "Fra eksisterende",
      "create-a-new": "Opret en ny",
      "sub-category-removed": "Underkategori fjernet!",
      "remove-sub-category": "Fjern underkategori",
      "remove-sub-category-confirm": "Fjern {{ x }} fra denne kategori? Den forbliver tilgængelig som en kategori på øverste niveau.",
      "update-category": "Opdatér kategori",
      "published-category-hint": "En offentliggjort kategori er synlig for alle butikker. Ikke-offentlige kategorier forbliver skjulte.",
      "category-updated-successfully": "Kategori opdateret!",
      "uninstalled": "Afinstalleret",
      "inactive": "Inaktiv",
      "install-at": "Installeret den",
      "total-chart-views": "Tabelvisninger",
      "chart-view-at": "Tabelvisning den",
      "store-id": "Butiks-ID",
      "successfully-deleted-clients": "Klienter slettet!",
      "session-replay": "Sessionsafspilning",
      "watch-on-amplitude": "Se på Amplitude",
      "shopify-app": "Shopify-app",
      "shops-online-store": "Butikkens onlinebutik",
      "no-more-events-to-load": "Ingen flere begivenheder at indlæse!",
      "failed-to-fetch-events": "Kunne ikke hente begivenheder!",
      "info": "Info",
      "store-info": "Butiksinfo",
      "days-ago": "for {{ x }} dage siden",
      "contact-email": "Kontakt-e-mail",
      "store-url": "Butiks-URL",
      "activities": "Aktiviteter",
      "insights": "Indsigter",
      "subscriptions": "Abonnementer",
      "failed-to-fetch-client-info": "Kunne ikke hente klientoplysninger!",
      "failed-to-load-add-to-cart-analytics": "Kunne ikke indlæse analyse af læg i kurv",
      "failed-to-load-buy-now-analytics": "Kunne ikke indlæse analyse af køb nu",
      "failed-to-load-chart-views": "Kunne ikke indlæse tabelvisninger",
      "failed-to-load-size-recommendations-analytics": "Kunne ikke indlæse analyse af størrelsesanbefalinger",
      "failed-to-load-stock-notifications-analytics": "Kunne ikke indlæse analyse af lagernotifikationer",
      "failed-to-load-stock-notifications-table": "Kunne ikke indlæse tabel over lagernotifikationer",
      "chart-views": "Tabelvisninger",
      "add-to-cart": "Læg i kurv",
      "buy-now": "Køb nu",
      "size-recommendations": "Størrelsesanbefalinger",
      "stock-notifications": "Lagernotifikationer",
      "change-details": "Ændr detaljer",
      "plan-subscription-details": "Detaljer om planabonnement",
      "ai-size-recommendation-limit": "Grænse for AI-størrelsesanbefaling",
      "ai-size-recommendation-limit-required": "Grænse for AI-størrelsesanbefaling er påkrævet!",
      "minimum-limit-is-0": "Minimumsgrænse er 0!",
      "unlimited": "Ubegrænset",
      "chart-limit-drafts-hint": "Kun offentliggjorte tabeller tæller. Kladder er ubegrænsede.",
      "chart-limit-required": "Tabelgrænse er påkrævet!",
      "chart-limit-whole-number": "Grænsen skal være et helt tal!",
      "stock-notification-limit": "Grænse for lagernotifikation",
      "stock-notification-limit-required": "Grænse for lagernotifikation er påkrævet!",
      "published-size-chart-limit": "Grænse for offentliggjorte størrelsestabeller",
      "published-table-chart-limit": "Grænse for offentliggjorte gittertabeller",
      "analytic": "Analyse",
      "full-suite": "Fuld pakke",
      "select-a-subscription-plan": "Vælg en abonnementsplan",
      "failed-to-fetch-plans": "Kunne ikke hente planer!",
      "new-plan": "Ny plan",
      "failed-to-assign-plan-subscription-to-client": "Kunne ikke tildele planabonnement til klient!",
      "ai-size-recommendation": "AI-størrelsesanbefaling",
      "stock-notification": "Lagernotifikation",
      "published-size-charts": "Offentliggjorte størrelsestabeller",
      "published-table-charts": "Offentliggjorte gittertabeller",
      "analytic-access": "Analyseadgang",
      "activated-at": "Aktiveret den",
      "usages": "Anvendelser",
      "failed-to-fetch-client-plan-subscription": "Kunne ikke hente klientens planabonnement!",
      "advanced-variant-mapping": "Avanceret variantmatchning",
      "advanced-variant-mapping-description": "Tabeller bruger deres egne størrelser på hvert tildelt produkt, og Læg i kurv vælger den matchende produktvariant. Når den er slået fra, skal en tabels størrelser svare nøjagtigt til hvert produkts variantnavne.",
      "advanced-variant-mapping-counts": "{{ total }} tabeller · {{ x }} med avanceret variantmatchning",
      "advanced-variant-mapping-drift": "{{ x }} tabeller matcher ikke denne indstilling.",
      "advanced-variant-mapping-repair": "Reparer",
      "turn-on-advanced-variant-mapping": "Slå avanceret variantmatchning til?",
      "turn-off-advanced-variant-mapping": "Slå avanceret variantmatchning fra?",
      "advanced-variant-mapping-on-body": "Alle {{ x }} tabeller for denne kunde skifter med det samme, og nye tabeller bruger den også. Målene ændres ikke, og du kan slå den fra igen.",
      "advanced-variant-mapping-off-body": "Alle {{ x }} tabeller for denne kunde går tilbage til nøjagtig matchning af variantnavne. Tabeller, hvis størrelser blev omdøbt, mens den var slået til (f.eks. \"Blue / S\" til \"S\"), viser tomme mål på produkter, hvis variantnavne ikke længere matcher.",
      "turn-on": "Slå til",
      "turn-off": "Slå fra",
      "failed-to-fetch-advanced-variant-mapping": "Kunne ikke hente avanceret variantmatchning!",
      "failed-to-update-advanced-variant-mapping": "Kunne ikke opdatere avanceret variantmatchning!",
      "plan-used-as-free-trial": "Plan brugt som gratis prøveperiode for nyregistrerede klienter",
      "x-usages": "{{ x }} anvendelser",
      "successfully-updated-configuration-value": "Konfigurationsværdi opdateret",
      "only-authorized-personnel-hint": "Kun autoriseret personale har tilladelse til at tilgå og ændre applikationens globale konfiguration!",
      "password-is-required": "Adgangskode er påkrævet",
      "authorize": "Godkend",
      "1-month": "1 måned",
      "3-months": "3 måneder",
      "6-months": "6 måneder",
      "1-year": "1 år",
      "failed-to-load-costs": "Kunne ikke indlæse omkostninger",
      "failed-to-load-total-recommendations": "Kunne ikke indlæse samlede anbefalinger",
      "archived": "Arkiveret",
      "billing-interval": "Faktureringsinterval",
      "plan-information": "Planoplysninger",
      "name-is-required": "Navn er påkrævet!",
      "features": "Funktioner",
      "stock-notification-recommendation-limit": "Grænse for lagernotifikationsanbefaling",
      "popular": "Populær",
      "allow-trial": "Tillad prøveperiode",
      "interval": "Interval",
      "interval-is-required": "Interval er påkrævet!",
      "price-is-required": "Pris er påkrævet!",
      "minimum-price-is-0": "Minimumspris er 0!",
      "discounted-from": "Nedsat fra",
      "description": "Beskrivelse",
      "description-is-required": "Beskrivelse er påkrævet!",
      "selling-points": "Salgsargumenter",
      "selling-point-x": "Salgsargument {{ x }}",
      "selling-point-is-required": "Salgsargument er påkrævet!",
      "analytic-is-required": "Analyse er påkrævet!",
      "support": "Support",
      "support-is-required": "Support er påkrævet!",
      "status-is-required": "Status er påkrævet!",
      "manage-preset-dimensions": "Administrér forudindstillede dimensioner, deres detektionssynonymer og oversættelser.",
      "detection-synonyms": "Detektionssynonymer",
      "add-synonym-placeholder": "Skriv et synonym og tryk på Enter",
      "translations": "Oversættelser",
      "missing-translation": "Manglende oversættelse",
      "new-dimension": "Ny dimension",
      "edit-dimension": "Redigér dimension",
      "delete-preset-dimension": "Slet forudindstillet dimension",
      "do-you-want-to-delete-this-preset-dimension": "Vil du slette \"{{ name }}\"?",
      "preset-dimensions-are-shared-by-every-store": "Forudindstillede dimensioner deles af alle butikker — sletning af én fjerner den fra alle kategorier, der bruger den. Dette kan ikke fortrydes.",
      "successfully-created-dimension": "Dimension oprettet!",
      "successfully-updated-dimension": "Dimension opdateret!",
      "successfully-deleted-dimension": "Dimension slettet!",
      "ai-provider-for-file-imports": "AI-udbyder til filimport",
      "no-api-key-configured-in-this-environment": "Der er ingen API-nøgle konfigureret i dette miljø",
      "ai-provider-saved-applies-to-new-imports": "AI-udbyder gemt. Den gælder for nye importer; importer, der allerede kører, beholder deres udbyder.",
      "ai-provider-for-size-recommendations": "AI-udbyder til størrelsesanbefalinger",
      "ai-provider-saved-applies-to-next-recommendation": "AI-udbyder gemt. Den gælder fra næste størrelsesanbefaling.",
      "size-recommendation-provider-hint": "Bruges til kundernes AI-størrelsesanbefalinger. Adskilt fra filimport.",
      "ai-measurement-import": "AI-import af mål",
      "name-admin-only": "Navn (kun for administratorer)",
      "name-admin-only-hint": "Appen genkender Free- og Enterprise-planerne på dette navn, så omdøb dem ikke.",
      "display-name": "Visningsnavn",
      "display-name-hint": "Vises for forhandlere på plansiden, faktureringssiderne og Shopify-betalingen. Lad feltet stå tomt for at bruge navnet.",
      "display-name-too-long": "Visningsnavnet må højst være 40 tegn!",
      "availability": "Tilgængelighed",
      "available-from-utc": "Tilgængelig fra (UTC)",
      "available-from-hint": "Lad feltet stå tomt for at tilbyde den, så snart den er aktiv.",
      "expires-at-utc": "Udløber (UTC)",
      "expires-at-required": "Angiv, hvornår den udløber!",
      "window-order": "Den skal blive tilgængelig, før den udløber!",
      "your-time": "Din tid: {{time}}",
      "availability-always": "Tilbydes altid",
      "availability-scheduled": "Planlagt: tilbydes endnu ikke",
      "availability-live": "Aktiv: tilbydes nu",
      "availability-ended": "Afsluttet: tilbydes ikke længere",
      "promo-plan": "Kampagneplan",
      "replaces-plan": "Erstatter",
      "replaces-plan-none": "Intet (en almindelig plan)",
      "replaces-plan-hint": "Mens denne plan tilbydes, ser forhandlere den i stedet for den plan, den erstatter.",
      "campaign": "Kampagne",
      "campaign-required": "Vælg den kampagne, som denne kampagneplan hører til!",
      "merchants-see": "Forhandlere ser",
      "replaces-x": "erstatter {{x}}",
      "archiving-hint": "Arkivering skjuler kun en plan for nye abonnenter. Nuværende abonnenter beholder den.",
      "duplicate-as-promo-plan": "Dupliker som kampagneplan",
      "help-articles": {
        "topic": "Emne",
        "all-topics": "Alle emner",
        "topics": {
          "getting-started": "Kom godt i gang",
          "size-charts": "Størrelsestabeller",
          "table-charts": "Gittertabeller",
          "assigning-products": "Tildeling til produkter",
          "storefront-display": "Visning i butikken",
          "chart-import": "Import af tabeller",
          "size-recommendations": "Størrelsesanbefalinger",
          "plans-billing": "Planer og fakturering",
          "troubleshooting": "Fejlfinding"
        },
        "new-article": "Ny hjælpeartikel",
        "slug": "Slug",
        "slug-hint": "Artiklens adresse i hjælpecenteret: /help/din-slug. Hvis du ændrer den, virker links til den gamle adresse ikke længere.",
        "slug-invalid": "Brug små bogstaver, tal og enkelte bindestreger.",
        "slug-taken": "En anden artikel bruger allerede denne slug.",
        "title-is-required": "Titel er påkrævet",
        "summary": "Resumé",
        "summary-hint": "Én linje. Supportassistenten vælger artikler ud fra resuméet.",
        "summary-is-required": "Resumé er påkrævet",
        "order": "Rækkefølge",
        "body-hint": "Markdown. Link til en anden artikel med [tekst](/help/dens-slug).",
        "insert-image": "Indsæt billede",
        "image-upload-failed": "Billedet kunne ikke uploades.",
        "view-on-help-centre": "Vis i hjælpecenteret",
        "broken-links": "Offentliggjort, men disse links peger på artikler, der ikke findes eller ikke er offentliggjort:",
        "article-saved": "Artikel gemt",
        "article-published": "Artikel offentliggjort",
        "article-unpublished": "Artikel afpubliceret",
        "article-deleted": "Artikel slettet",
        "delete-article": "Slet artikel",
        "delete-article-prompt": "Slet \"{{title}}\"? Den forsvinder straks fra hjælpecenteret og supportassistenten.",
        "load-failed": "Artiklen kunne ikke indlæses.",
        "export": "Eksportér",
        "import": "Importér",
        "export-failed": "Artiklerne kunne ikke eksporteres.",
        "import-title": "Importér hjælpeartikler",
        "import-checking": "Tjekker filen…",
        "import-preview": "{{file}} opretter {{created}} og opdaterer {{updated}} artikler med {{images}} billeder. Artikler, der ikke er i filen, forbliver uændrede.",
        "import-invalid": "Denne fil kan ikke importeres:",
        "imported": "Importeret: {{created}} oprettet, {{updated}} opdateret."
      },
      "invite-only": "Kun efter invitation",
      "invite-only-hint": "Skjult på abonnementssiden. Alle med linket kan abonnere. Dette kan ikke ændres, efter abonnementet er oprettet.",
      "invite-only-price-required": "Et abonnement kun efter invitation skal have en pris over 0",
      "copy-invite-link": "Kopiér invitationslink",
      "invite-link-copied": "Invitationslink kopieret",
      "invite-link-copy-failed": "Invitationslinket kunne ikke kopieres"
    }
  },
  "search": {
    "no-result-found": "Ingen resultater fundet!",
    "type": {
      "product": "Produkt",
      "variant": "Variant",
      "client": "Klient"
    },
    "show-less": "Vis mindre",
    "show-full": "Vis alle",
    "search-x-by-full-name": "Søg {{ x }} efter fulde navn",
    "load-more...": "Indlæs mere..."
  },
  "privacy-policy": "Privatlivspolitik",
  "contact-us": "Kontakt os",
  "notification": {
    "notification": "Notifikation",
    "mark-all-as-read": "Markér alle som læst",
    "compose": "Opret notifikation",
    "title-required": "Titel er påkrævet!",
    "message-required": "Besked er påkrævet!",
    "sent-to-all-clients": "En notifikation er sendt til alle klienter"
  },
  "table": {
    "sort": "Sortér",
    "sort-by": "Sortér efter",
    "oldest-first": "Ældste først",
    "newest-first": "Nyeste først",
    "a-z": "A til Å",
    "z-a": "Å til A",
    "lowest-first": "Laveste først",
    "highest-first": "Højeste først",
    "no-data-found": "Ingen data fundet"
  },
  "grading": {
    "grading-configuration": "Gradueringskonfiguration",
    "base-size": "Basisstørrelse",
    "enter-your-grading-allowances": "Indtast dine gradueringstolerancer",
    "base": "Basis"
  },
  "chart": {
    "image-nav-previous": "Forrige billede",
    "image-nav-next": "Næste billede",
    "image-nav-position": "{{current}} / {{total}}",
    "image-add-slot-placeholder": "Tilføj et billede mere",
    "image-add-slot-formats": "Accepterer .png, .jpeg, .jpg",
    "image-cap-reached": "Du har nået det maksimale antal billeder for denne kategori.",
    "image-upload-failed": "Billedet kunne ikke uploades. Prøv igen.",
    "image-svg-not-accepted": "SVG-filer accepteres ikke her.",
    "image-delete": "Slet billede",
    "image-move-left": "Flyt billede til venstre",
    "image-move-right": "Flyt billede til højre",
    "image-delete-confirm-title": "Slet dette billede?",
    "image-delete-confirm-body": "Dette billede bliver fjernet permanent og kan ikke gendannes.",
    "image-delete-confirm-cancel": "Annullér",
    "image-delete-confirm-action": "Slet billede",
    "image-delete-last-tooltip": "En kategori skal have mindst ét billede.",
    "image-customize-first-tooltip": "Tilpas først denne kategori for at administrere dens billeder.",
    "image-delete-failed": "Billedet kunne ikke slettes. Prøv igen.",
    "image-reorder-failed": "Billederne kunne ikke omarrangeres. Prøv igen.",
    "do-you-want-to-delete-this-chart": "Vil du slette denne tabel?",
    "unnamed-chart": "Unavngiven tabel",
    "get-size-chart-permalink": "Hent permanent link til størrelsestabel",
    "chart-external-link-is-copied-to-clipboard": "Tabellens eksterne link er kopieret til udklipsholderen",
    "failed-to-duplicate-chart": "Kunne ikke duplikere tabel",
    "failed-to-create-chart": "Kunne ikke oprette tabel",
    "add-new-layout-blocks": "Tilføj nye layoutblokke",
    "click-on-these-layout-types-and-add-to-the-size-chart": "Klik på disse layouttyper, og tilføj dem til størrelsestabellen",
    "rename-chart": "Omdøb tabel",
    "chart-renamed-successfully": "Tabel omdøbt",
    "failed-to-rename-chart": "Kunne ikke omdøbe tabel",
    "preview": "Forhåndsvisning",
    "model-info": "Modeloplysninger",
    "model-details": "Modeldetaljer",
    "help-shoppers-by-showing-the-model-height-and-size": "Hjælp kunder ved at vise modellens højde og størrelse",
    "model-name": "Modelnavn",
    "enter-model-name": "Indtast modelnavn",
    "model-height": "Modelhøjde",
    "please-enter-valid-number": "Indtast venligst et gyldigt tal",
    "size-worn": "Anvendt størrelse",
    "show-variants-by": "Vis varianter efter",
    "add-options-like-size-or-color": "Tilføj valgmuligheder som størrelse eller farve",
    "select-existing-chart": "Vælg eksisterende tabel",
    "search-charts": "Søg tabeller efter navn",
    "no-charts-found": "Ingen tabeller fundet",
    "search-dimensions": "Søg dimensioner",
    "no-dimensions-found": "Ingen dimensioner fundet",
    "add-a-new-size-chart": "Tilføj en ny størrelsestabel",
    "this-product-is-using-table-chart": "Dette produkt bruger en gittertabel",
    "update-your-size-chart": "Opdatér din størrelsestabel",
    "create-your-size-chart": "Opret din størrelsestabel",
    "use-a-template": "Brug en skabelon",
    "use-template-variants": "Brug skabelon og varianter",
    "pick-a-method-to-get-started": "Vælg en metode for at komme i gang",
    "select-an-existing-chart": "Vælg en eksisterende tabel",
    "image-set-annotation-panel": "Annotationspanel for billedsæt",
    "measure-guide": "Målevejledning...",
    "drag-drop-to-mark-measurement-bubble": "Træk og slip for at markere målpunkt",
    "are-you-sure-you-want-to-delete-all-measurements": "Er du sikker på, at du vil slette alle mål?",
    "accepts-png-jpeg-jpg-svg": "Accepterer .png, .jpeg, .jpg, .svg",
    "this-name-will-appear-in": "Dette navn vises i",
    "image-set": "billedsæt",
    "added-measurements": "Tilføjede mål",
    "no-measurements-added-yet": "Ingen mål tilføjet endnu",
    "drag-and-drop-a-chip-to-edit-its-line-on-the-canvas": "Træk og slip en chip for at redigere dens linje på lærredet",
    "after-adding-a-measurement-drag-and-drop-it-from-the-section-above-onto-the-image": "Efter du har tilføjet et mål, skal du trække det fra afsnittet 'Tilføjede mål' ovenfor og over på billedet",
    "across-shoulder-front-rise-belt": "Skulderbredde, forlængde, bælte, ...",
    "create-measurement": "Opret mål",
    "examples-across-shoulder-front-rise-cuff-width": "Eksempler: 'Skulderbredde', 'Forlængde', 'Manchetbredde'",
    "delete-anotation-set": "Slet annotationssæt",
    "this-will-remove-all-measurements-from-this-image": "Dette vil fjerne alle mål fra dette billede",
    "measurement-name": "Målnavn",
    "size-recommender": "Størrelsesanbefaler",
    "size-recommender-history": "Seneste anbefalinger",
    "your-buyer-personal-fitting-assistant-that-instantly-suggests-the-perfect-size-every-time": "Din kundes personlige tilpasningsassistent, der øjeblikkeligt foreslår den perfekte størrelse, hver gang",
    "stretch-factor": "Strækfaktor",
    "how-stretchy-is-the-fabric-a-rough-estimate-is-enough-if-unsure-then-leave-at-10": "Hvor elastisk er stoffet? Et groft skøn er nok. Hvis du er i tvivl, så lad det stå på 10%",
    "easing": "Bevægelsesrum",
    "wearing-ease-is-the-amount-added-to-a-person-body-measurements-so-one-can-move-in-a-garment": "Bevægelsesrum er den mængde, der lægges til en persons kropsmål, så man kan bevæge sig i en beklædningsgenstand.",
    "set-default": "Angiv som standard",
    "suggested": "Foreslået",
    "assign-chart": "Tildel tabel",
    "your-chart-has-not-been-assigned-to-any-product-yet": "Din tabel er endnu ikke tildelt noget produkt",
    "assign-your-chart-so-it-will-appear-on-product-pages": "Tildel din tabel, så den vises på produktsider",
    "assign-it-to-a-product": "Tildel den til et produkt",
    "select-the-products-or-collections-where-you-want-your-size-chart-to-appear": "Vælg de produkter eller kollektioner, hvor du vil have din størrelsestabel til at vises",
    "x-matched-y": "{{ x }} matchede {{ y }}",
    "overwritting-x-products": "(overskriver {{ x }} produkter)",
    "calculating...": "Beregner...",
    "select-product-or-collection": "Vælg produkt eller kollektion",
    "remove-all": "Fjern alle",
    "are-you-sure-you-want-to-remove-all-conditions": "Er du sikker på, at du vil fjerne alle betingelser?",
    "list-of-matched-products": "Liste over matchede produkter",
    "give-your-size-chart-a-name": "Giv din størrelsestabel et navn",
    "this-name-is-only-used-internally-to-help-you-organise-your-charts-customers-wont-see-it": "Dette navn bruges kun internt til at hjælpe dig med at organisere dine tabeller. Kunder vil ikke se det.",
    "eg-mens-t-shirt-size-chart": "f.eks. Størrelsestabel til herre-T-shirts",
    "add-text-block": "Tilføj tekstblok",
    "product-image-optional": "Produktbillede (valgfrit)",
    "add-layout-block": "Tilføj layoutblok",
    "move-this-block-up": "Flyt denne blok op",
    "move-this-block-down": "Flyt denne blok ned",
    "clear-this-image": "Ryd dette billede",
    "align-this-image": "Justér dette billede",
    "clear-this-video": "Ryd denne video",
    "apply-grading-to-this-table": "Anvend graduering på denne tabel",
    "duplicate-this-block-to-below": "Duplikér denne blok nedenfor",
    "remove-this-block": "Fjern denne blok",
    "upload-an-image": "Upload et billede",
    "browse-to-upload": "Gennemse for at uploade",
    "choose-from-our": "Vælg blandt vores",
    "ready-made-templates": "færdige skabeloner",
    "select-a-template": "Vælg en skabelon",
    "new-row": "Ny række",
    "new-column": "Ny kolonne",
    "add-column-left": "Tilføj kolonne til venstre",
    "add-column-right": "Tilføj kolonne til højre",
    "move-left": "Flyt til venstre",
    "move-right": "Flyt til højre",
    "freeze": "Frys",
    "unfreeze": "Fjern frysning",
    "delete-column": "Slet kolonne",
    "add-row-above": "Tilføj række ovenfor",
    "add-row-below": "Tilføj række nedenfor",
    "move-up": "Flyt op",
    "move-down": "Flyt ned",
    "delete-row": "Slet række",
    "insert-video": "Indsæt video",
    "select-a-video": "Vælg en video",
    "paste-a-link-to-a-video-here": "Indsæt et link til en video her",
    "webgl-not-supported": "Din browser understøtter ikke WebGL. Slå venligst WebGL-understøttelse til, hvis du bruger en moderne browser som Chrome, Firefox eller Safari.",
    "table-chart-created": "Gittertabel oprettet",
    "name-this-image-set": "Navngiv dette billedsæt",
    "name-your-import": "Navngiv din import",
    "table-chart-updated": "Gittertabel opdateret",
    "chart-updated": "Tabel opdateret",
    "use-how-to-measure-block": "Brug 'sådan måler du'-blok? (Valgfrit)",
    "a-text-block-under-an-expandable-panel-will-be-added-where-you-can-fill-in-details-for-your-customers-on-how-to-measure-their-measurements": "En tekstblok under et udvideligt panel tilføjes, hvor du kan udfylde detaljer for dine kunder om, hvordan de skal måle deres mål",
    "newest-5-recommendations-given-to-your-customers": "De 5 nyeste anbefalinger givet til dine kunder",
    "size-recommended": "Anbefalet størrelse",
    "view-all-data": "Se alle data",
    "please-select-a-size-worn": "Vælg venligst en anvendt størrelse",
    "recommended-for-this-garment-add-or-remove-as-needed": "Anbefalet til denne beklædningsgenstand, tilføj eller fjern efter behov",
    "add-more": "Tilføj flere",
    "add-custom-measurements": "Tilføj brugerdefinerede mål",
    "skip-this-step-next-time": "Spring dette trin over næste gang",
    "use-unit-conversion": "Brug enhedskonvertering",
    "disabled-by-chart": "Deaktiveret af tabel",
    "disabled-globally-by-settings": "Deaktiveret globalt via indstillinger",
    "hide-unit-conversion-toggle-on-all-charts-appear-on-your-storefront": "Skjul enhedskonverteringsknap på alle tabeller, der vises i din webshop",
    "assign-products": "Tildel produkter",
    "select-products-to-assign-to-the-chart": "Vælg produkter, der skal tildeles tabellen",
    "products-assigned-successfully": "Produkter tildelt",
    "source-table": "Kildetabel",
    "root-table": "Hovedtabel",
    "table-block": "Tabel",
    "which-axis-holds-the-dimension-data": "Hvilken akse indeholder dimensionsdataene? (Skulder, talje, osv.)",
    "columns": "Kolonner",
    "rows": "Rækker",
    "measurement-unit": "Måleenhed",
    "map-each-line-to-a-dimension": "Tilknyt hver linje til en dimension",
    "ignore": "Ignorér",
    "line": "Linje",
    "the-selected-table-has-no-data-to-map": "Den valgte tabel har ingen data at tilknytte.",
    "tell-us-how-your-table-maps-to-body-dimensions-so-we-can-suggest-a-size": "Fortæl os, hvordan din tabel matcher kropsdimensioner, så vi kan foreslå en størrelse.",
    "choose-which-table-the-ai-reads-to-suggest-a-size": "Vælg hvilken tabel AI'en læser for at foreslå en størrelse.",
    "per-dimension-stretch-and-easing-controls": "Styring af stræk og bevægelsesrum pr. dimension",
    "jump-to-table": "Gå til tabel",
    "scroll-to-the-selected-table": "Rul til den valgte tabel",
    "this-table-is-used-as-your-size-recommendation-data-source": "Denne tabel bruges som datakilde til din størrelsesanbefaling",
    "this-table-block-can-not-be-deleted-right-now": "Denne tabelblok kan ikke slettes lige nu"
  },
  "error": {
    "there-was-an-error-while-authenticating-your-store": "Der opstod en fejl under godkendelse af din butik!",
    "click-the-button-below-to-try-again-if-the-issue-persisted-contact-us-for-further-instruction": "Klik på knappen nedenfor for at prøve igen. Hvis problemet fortsætter, så kontakt os for yderligere instruktioner.",
    "refresh-the-app": "Opdatér appen",
    "error-occured": "Der opstod en fejl!"
  },
  "banner": {
    "add-the-goodchart-size-guide-button-to-your-storefront": "Tilføj Goodchart-størrelsesguideknappen til din webshop",
    "we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block": "Vi har registreret, at du integrerer med Shopify. Aktivér app-indlejring for automatisk at vise størrelsesguideknappen på hver produktside, eller tilføj en app-blok for at placere den et bestemt sted. Brug for hjælp? Se denne <a class=\"underline\" href=\"{{ guide }}\" target=\"_blank\">vejledning</a>.",
    "enable-app-embed": "Aktivér app-indlejring",
    "add-app-block": "Tilføj app-blok",
    "your-new-size-chart-is-ready-to-review": "Din nye størrelsestabel er klar til gennemgang",
    "look-around-then-hand-the-conversion-over": "Der er endnu ikke sket noget for dine kunder — din gittertabel er stadig den aktive. Tag din tid til at tjekke mål og vejledning, og overdrag derefter konverteringen, når det ser rigtigt ud.",
    "about-your-plan-usage": "Om dit planforbrug",
    "measurements-applied": "Mål anvendt",
    "selection-applied-all-variants": "Valget er blevet anvendt på alle størrelsesvarianter.",
    "you-have-reached-x-of-ai-size-recommendations-limit": "Du har nået {{ x }}% af din nuværende plans grænse for AI-størrelsesanbefalinger. Vær opmærksom på, at forbrug over 100% vil blive opkrævet til standardtakst.",
    "you-have-reached-x-of-stock-notification-limit": "Du har nået {{ x }}% af din nuværende plans grænse for lagernotifikationer.",
    "over-usage-cost": "Overforbrugsomkostning",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service": "Du har overskredet din grænse for AI-størrelsesanbefaling. Fortsæt venligst med at betale overforbrugsomkostningen for at blive ved med at bruge tjenesten.",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-this-feature": "Du har overskredet din grænse for AI-størrelsesanbefaling. Fortsæt venligst med at betale overforbrugsomkostningen for at blive ved med at bruge denne funktion.",
    "n-of-your-table-charts-can-be-upgraded-to-smart-size-charts": "{{count}} af dine gittertabeller kan opgraderes til smarte størrelsestabeller"
  },
  "onboarding": {
    "skip-for-now": "Spring over for nu",
    "step-x-of-y": "Trin {{ x }} af {{ y }}",
    "select-the-category-that-best-matches-your-product": "Vælg den kategori, der bedst matcher dit produkt.",
    "apparel": "Beklædning",
    "tops": "Overdele",
    "pants": "Bukser",
    "dresses": "Kjoler",
    "shoes": "Sko",
    "sneakers": "Sneakers",
    "boots": "Støvler",
    "sandals": "Sandaler",
    "accessories": "Tilbehør",
    "belts": "Bælter",
    "bags": "Tasker",
    "hats": "Hatte",
    "other-custom": "Andet/tilpasset",
    "equipment": "Udstyr",
    "tool": "Værktøj",
    "furniture": "Møbler",
    "upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories": "Upload et hvilket som helst produktbillede, og placér mål visuelt. Fungerer til beklædning, sko og tilbehør.",
    "table-style-chart": "Tabel i gitterstil",
    "create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications": "Opret en gitterbaseret tabel med rækker og kolonner. Bedst til detaljerede størrelsesspecifikationer.",
    "your-size-chart-is-ready": "Din størrelsestabel er klar",
    "you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later": "Du kan nu beslutte, hvor denne størrelsestabel skal vises i din butik. Du kan springe dette trin over og tildele produkter senere.",
    "apply-this-chart-to-products-now": "Anvend denne tabel på produkter nu",
    "choose-which-products-should-use-this-size-chart": "Vælg hvilke produkter der skal bruge denne størrelsestabel.",
    "i-ll-do-this-later": "Jeg gør det senere",
    "you-can-assign-or-change-matching-anytime-from-chart-settings": "Du kan tildele eller ændre matchning når som helst fra tabelindstillinger.",
    "select-products-to-assign-chart-to": "Vælg produkter, tabellen skal tildeles",
    "apply-this-chart-to-all-products": "Anvend denne tabel på alle produkter.",
    "select-products-to-apply-this-chart-to": "Vælg produkter, denne tabel skal anvendes på.",
    "assigning...": "Tildeler...",
    "size-chart-created-successfully": "Størrelsestabel oprettet",
    "you-can-assign-products-anytime-from-chart-settings": "Du kan tildele produkter når som helst fra tabelindstillinger.",
    "view-chart": "Se tabel",
    "go-to-dashboard": "Gå til dashboard",
    "turn-your-size-chart-into-a-conversion-tool": "Gør din størrelsestabel til et konverteringsværktøj",
    "help-shoppers-pick-the-right-size-and-reduce-returns": "Hjælp kunder med at vælge den rigtige størrelse og reducér returneringer.",
    "setup-takes-about-2-minutes": "Opsætning tager omkring 2 minutter.",
    "choose-how-your-size-chart-looks": "Vælg hvordan din størrelsestabel skal se ud",
    "other-ways-to-create-a-chart": "Andre måder at oprette en tabel på",
    "failed-to-proceed-please-try-again": "Kunne ikke fortsætte, prøv venligst igen",
    "this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart": "Denne tabel forbinder til dit Shopify-produkt og varianter, så kunder kan vælge deres størrelse, lægge i kurv eller købe nu uden at forlade tabellen",
    "add-the-size-guide-button-to-your-storefront": "Tilføj størrelsesguideknappen til din webshop",
    "choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages": "Vælg hvordan GoodChart-størrelsesguideknappen skal vises på dine produktsider.",
    "enable-app-embed": "Aktivér app-indlejring",
    "installed": "Installeret",
    "automatically-display-the-size-guide-button-on-all-product-pages": "Vis automatisk størrelsesguideknappen på alle produktsider.",
    "add-app-block-to-product-page": "Tilføj app-blok til produktside",
    "prefer-to-place-the-button-in-a-specific-spot-on-your-product-page": "Foretrækker du at placere knappen et bestemt sted på din produktside?",
    "place-the-size-guide-button-in-a-specific-spot-on-your-product-page-template": "Placér størrelsesguideknappen et bestemt sted i din produktsideskabelon.",
    "open": "Åbn",
    "check-button-installation": "Tjek knapinstallation",
    "checking": "Tjekker...",
    "great-the-size-guide-button-is-installed-on-your-storefront": "Fantastisk! Størrelsesguideknappen er installeret i din webshop.",
    "we-could-not-detect-the-size-guide-button-yet-please-make-sure-you-saved-the-changes-in-the-theme-editor": "Vi kunne endnu ikke registrere størrelsesguideknappen. Sørg venligst for, at du har gemt ændringerne i temaeditoren.",
    "app-block-installed-on-your-product-page": "App-blok installeret på din produktside"
  },
  "common": {
    "updated": "Opdateret",
    "name": "Navn",
    "avatar": "Avatar",
    "category-image": "Kategoribillede",
    "increase": "Forøg",
    "created": "Oprettet",
    "email": "E-mail",
    "password": "Adgangskode",
    "yes": "Ja",
    "no": "Nej",
    "chart": "Tabel",
    "gender": "Køn",
    "height": "Højde",
    "weight": "Vægt",
    "age-group": "Aldersgruppe",
    "fit-preference": "Pasformspræference",
    "score": "Score",
    "table-chart": "Gittertabel",
    "draft": "Kladde",
    "active": "Aktiv",
    "products": "Produkter",
    "none": "Ingen",
    "cancel": "Annullér",
    "retry": "Prøv igen",
    "delete": "Slet",
    "export": "Eksportér",
    "variant": "Variant",
    "variants": "Varianter",
    "account": "Konto",
    "personal": "Personlig",
    "appearance": "Udseende",
    "organization": "Organisation",
    "information": "Oplysninger",
    "first-name": "Fornavn",
    "last-name": "Efternavn",
    "save": "Gem",
    "pay": "Betal",
    "undo": "Fortryd",
    "redo": "Gentag",
    "newsletter-subscription": "Nyhedsbrevsabonnement",
    "button": "Knap",
    "colour": "Farve",
    "default": "Standard",
    "white": "Hvid",
    "light-grey": "Lysegrå",
    "soft-beige": "Blød beige",
    "saving...": "Gemmer...",
    "all-changes-saved": "Alle ændringer gemt",
    "publish": "Offentliggør",
    "unpublish": "Afpublicér",
    "images": "Billeder",
    "charts": "Tabeller",
    "confirm": "Bekræft",
    "dimensions": "Dimensioner",
    "new": "Ny",
    "missing": "Mangler",
    "editing-x": "Redigerer {{ x }}",
    "back-in-stock": "Tilbage på lager",
    "product": "Produkt",
    "grading": "Graduering",
    "more-actions": "Flere handlinger",
    "table": "Tabel",
    "measurement": "Mål",
    "close": "Luk",
    "apply": "Anvend",
    "duplicate": "Duplikér",
    "add-layout-blocks": "Tilføj layoutblokke",
    "text": "Tekst",
    "image": "Billede",
    "video": "Video",
    "new-name": "Nyt navn",
    "published": "Offentliggjort",
    "all": "Alle",
    "editing": "Redigerer",
    "show-more": "Vis mere",
    "loading": "Indlæser",
    "or": "Eller",
    "browse-files": "Gennemse filer",
    "edit": "Redigér",
    "customize": "Tilpas",
    "clear": "Ryd",
    "label": "Etiket",
    "discard-changes": "Kassér ændringer",
    "uploading": "Uploader...",
    "preset": "Forudindstilling",
    "custom": "Brugerdefineret",
    "manage": "Administrér",
    "done": "Færdig",
    "reminder": "Påmindelse",
    "collections": "Kollektioner",
    "all-products": "Alle produkter",
    "select": "Vælg",
    "search": "Søg",
    "select-all": "Vælg alle",
    "size-chart": "Størrelsestabel",
    "continue": "Fortsæt",
    "back": "Tilbage",
    "visual-measurement-builder": "Visuel målebygger",
    "recommend": "Anbefal",
    "creating...": "Opretter...",
    "syncing": "Synkroniserer...",
    "preview": "Forhåndsvisning",
    "create": "Opret",
    "onboarding": "Onboarding",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "czech": "Čeština",
    "danish": "Dansk",
    "german": "Tysk",
    "italian": "Italiensk",
    "dutch": "Nederlandsk",
    "japanese": "Japansk",
    "off": "Fra",
    "basic": "Grundlæggende",
    "AI": "AI",
    "details": "Detaljer",
    "date": "Dato",
    "billing": "Fakturering",
    "settings": "Indstillinger",
    "log-out": "Log ud",
    "plan": "Plan",
    "ai-size-recommendation": "AI-størrelsesanbefaling",
    "recommendations": "Anbefalinger",
    "features": "Funktioner",
    "stock-notification": "Lagernotifikation",
    "published-size-charts": "Offentliggjorte størrelsestabeller",
    "published-table-charts": "Offentliggjorte gittertabeller",
    "unlimited": "Ubegrænset",
    "x-of-y": "{{ x }} af {{ y }}",
    "measurements": "Mål",
    "selected": "Valgt",
    "select-product": "Vælg produkt",
    "price": "Pris",
    "title": "Titel",
    "message": "Besked",
    "add": "Tilføj",
    "remove": "Fjern",
    "cm": "cm",
    "in": "tommer",
    "usd": "USD",
    "return": "Retur",
    "next": "Næste",
    "store": "Butik",
    "type": "Type",
    "cost": "Omkostning",
    "incurred-at": "Pådraget den",
    "search-placeholder": "Søg...",
    "more": "Mere...",
    "load-more": "Indlæs mere...",
    "status": "Status",
    "enabled": "Aktiveret",
    "disabled": "Deaktiveret",
    "total": "I alt",
    "un-listed": "Ikke offentliggjort",
    "global": "Global",
    "store-specific": "Butiksspecifik",
    "ai-measurement-import": "AI-import af mål",
    "included": "Inkluderet",
    "not-included": "Ikke inkluderet"
  },
  "snackbar": {
    "successfully-updated-your-preferences": "Dine præferencer blev opdateret",
    "failed-to-update-your-preferences": "Kunne ikke opdatere dine præferencer"
  },
  "import": {
    "upload-file": "Upload fil",
    "sheet-import": {
      "title": "Upload mål fra en fil",
      "dropzone": {
        "title": "Træk og slip en fil her",
        "accepted-types": "{{types}} – én fil ad gangen",
        "browse": "Gennemse filer"
      },
      "hint": "Bedste resultater: én tabel, hvor størrelserne svarer til denne størrelsestabels varianter, med overskrifter i første række eller kolonne. Et billede eller skærmbillede skal være skarpt, taget lige forfra og beskåret til kun tabellen.",
      "example": {
        "caption": "Eksempel på et accepteret layout:",
        "size": "Størrelse",
        "chest": "Bryst (cm)",
        "waist": "Talje (cm)"
      },
      "error": {
        "invalid-type": "Den filtype understøttes ikke. Upload en af disse: {{types}}.",
        "heic-unsupported": "HEIC-billeder (iPhone-formatet) understøttes ikke. Eksportér billedet som JPG eller PNG, og upload den fil i stedet.",
        "file-too-large": "Filen er for stor. Den maksimale størrelse er {{maxSizeMb}} MB."
      },
      "submit": "Upload og gennemgå ændringer",
      "running": {
        "this-chart": "Der kører allerede en import for denne størrelsestabel.",
        "other-chart": "Der kører allerede en import for en anden størrelsestabel. Der kan kun køre én import ad gangen.",
        "open-import": "Se import"
      },
      "accepted-files-tooltip": "Accepterede filer: {{types}}",
      "button": {
        "importing": "Importerer… {{progress}} %",
        "review": "Gennemgå import"
      }
    }
  },
  "size-recommender": {
    "form": {
      "title": "Find din bedste størrelse",
      "subtitle": "Et par hurtige detaljer for en bedre pasform",
      "shopping-for": "SHOPPER TIL",
      "women": "Kvinder",
      "men": "Mænd",
      "other": "Andet",
      "measurements": "MÅL",
      "height": "Højde",
      "height-required": "Højde er påkrævet",
      "min-height": "Mindste højde er 1",
      "weight": "Vægt",
      "weight-required": "Vægt er påkrævet",
      "min-weight": "Mindste vægt er 1",
      "preferred-fit": "Foretrukken pasform"
    },
    "result": {
      "suggested-size": "Foreslået størrelse:",
      "no-fit": "Det ser desværre ud til, at vi ikke har en ideel størrelse lige nu. Vi anbefaler, at du kigger igen senere for flere muligheder.",
      "verdict": "Dom:",
      "similar-variants": "Lignende varianter:",
      "proceed": "Fortsæt med denne variant",
      "estimate-disclaimer": "(Estimat baseret på brand og brugeroplysninger, resultater kan variere.)"
    },
    "ai": {
      "upgrade-title": "Opgradér din plan for at låse op for AI-størrelsesanbefaling",
      "upgrade-description": "En funktion, der hjælper dine kunder med at finde den rigtige størrelse hver gang. Vores AI analyserer produktdetaljer og kundeinput for at give personlige størrelsesforslag, så kunder køber med tillid, og du ser færre returneringer og ombytninger. Opgradér nu for at tilbyde denne oplevelse i din butik.",
      "image-alt": "Størrelsesanbefaling",
      "upgrade-enable": "Opgradér og aktivér nu",
      "explore-plans": "Udforsk andre planer",
      "failed-load-recommendations": "Kunne ikke indlæse anbefalinger",
      "failed-fetch-plans": "Kunne ikke hente planer",
      "form-tab": "Formular",
      "result-tab": "Resultat"
    },
    "basic": {
      "measurements-required-title": "Tilføj mål først",
      "measurements-required-description": "Grundlæggende størrelsesanbefaling finder en størrelse til køberne ud fra denne tabels mål. Tilføj mål til tabellen, og slå den derefter til."
    }
  },
  "chart-limit": {
    "title-size": "Du har nået din grænse for offentliggjorte størrelsestabeller",
    "title-table": "Du har nået din grænse for offentliggjorte gittertabeller",
    "description-size": "Din plan giver dig mulighed for at offentliggøre {{limit}} størrelsestabeller, og du har {{usage}} offentliggjort. Denne tabel er gemt som kladde. Opgradér for at offentliggøre flere, eller fjern offentliggørelsen af en tabel, du ikke længere har brug for.",
    "description-table": "Din plan giver dig mulighed for at offentliggøre {{limit}} gittertabeller, og du har {{usage}} offentliggjort. Denne tabel er gemt som kladde. Opgradér for at offentliggøre flere, eller fjern offentliggørelsen af en tabel, du ikke længere har brug for.",
    "upgrade-plan": "Opgradér plan",
    "explore-plans": "Udforsk planer",
    "failed-fetch-plans": "Planerne kunne ikke indlæses. Prøv igen.",
    "image-alt": "Tabelillustration",
    "onboarding-saved-as-draft": "Din tabel er gemt som kladde, fordi din plans grænse for offentliggjorte tabeller er nået. Du kan offentliggøre den efter at have opgraderet eller fjernet offentliggørelsen af en anden tabel."
  },
  "help-centre": "Hjælpecenter",
  "dimension-inputs": {
    "add-measurement": "Tilføj mål"
  },
  "variant-editor": {
    "option-name": "Valgnavn",
    "option-values": "Valgværdier",
    "option-placeholder": "Størrelse / Farve / Stof",
    "add-option": "Tilføj endnu et valg"
  },
  "dimension": {
    "shoulder": "Skulder",
    "bust": "Buste",
    "waist": "Talje",
    "arm": "Arm",
    "sleeve": "Ærme",
    "hip": "Hofte",
    "crotch": "Skridt",
    "leg": "Ben",
    "thigh": "Lår",
    "length": "Længde",
    "bottom_width": "Bundbredde",
    "chest": "Bryst",
    "inside_leg": "Indvendig benlængde",
    "back_length": "Ryglængde",
    "front_length": "Forlængde",
    "front_rise": "Forstigning",
    "back_rise": "Bagstigning",
    "leg_opening": "Benåbning",
    "overbust": "Overbryst",
    "underbust": "Underbryst",
    "groups": {
      "tops": "Overdele",
      "bottoms": "Underdele",
      "generals": "Generelle"
    }
  },
  "analytic": {
    "range": {
      "1m": "1 måned",
      "3m": "3 måneder",
      "6m": "6 måneder",
      "1y": "1 år"
    }
  },
  "store-history": {
    "a-restore-is-already-running-for-this-store": "Der kører allerede en gendannelse for denne butik. Vent til den er færdig, og prøv igen.",
    "a-snapshot-is-taken-only-on-days-you-change-something": "Der tages kun en sikkerhedskopi på dage, hvor du ændrer noget.",
    "actor": {
      "merchant": "dig",
      "support": "Goodchart-support",
      "system": "Shopify"
    },
    "billing-plan-login-and-connected-integrations-are-not-touched": "Din fakturering, dit abonnement, dit login og dine forbundne integrationer røres ikke.",
    "blocked": {
      "entity-exists": "Allerede genskabt — gendan i stedet",
      "entity-missing": "Findes ikke længere — gendan i stedet",
      "unsupported": "Kan ikke fortrydes — gendan i stedet",
      "value-changed": "Ændret siden — gendan i stedet"
    },
    "changes": "Ændringer",
    "discard-unsaved-changes": "Kassér ikke-gemte ændringer?",
    "dont-ask-again-in-this-session": "Spørg ikke igen i denne session",
    "earlier": "Tidligere",
    "history": "Historik",
    "history-starts-from-your-first-snapshot": "Historikken starter ved din første sikkerhedskopi",
    "label": {
      "category-created": "Kategori {{name}} oprettet",
      "category-deleted": "Kategori {{name}} slettet",
      "category-updated": "Kategori {{name}} redigeret",
      "chart-created": "Størrelsesguide {{name}} oprettet",
      "chart-deleted": "Størrelsesguide {{name}} slettet",
      "chart-updated": "Størrelsesguide {{name}} redigeret",
      "dimension-created": "Mål {{name}} oprettet",
      "dimension-deleted": "Mål {{name}} slettet",
      "dimension-updated": "Mål {{name}} redigeret",
      "draft-assignment-rules": "Tildelingsregler ændret",
      "draft-edited": "Tabel redigeret",
      "draft-guide": "Måleguide redigeret",
      "draft-labels": "Størrelsesmærkater redigeret",
      "draft-measurements": "Mål redigeret",
      "draft-model": "Modelmål ændret",
      "draft-publication": "Udgivelse ændret",
      "draft-renamed": "Tabel omdøbt",
      "draft-size-recommender": "Størrelsesanbefaling ændret",
      "draft-variants": "Varianter redigeret",
      "keyword-created": "Nøgleord {{name}} oprettet",
      "keyword-deleted": "Nøgleord {{name}} slettet",
      "keyword-updated": "{{count}} nøgleord redigeret",
      "products-assigned": "{{count}} produkter tilknyttet",
      "profile-updated": "Butiksprofil opdateret",
      "store-restored": "Butik gendannet til {{date}}",
      "table-chart-created": "Tabel {{name}} oprettet",
      "table-chart-deleted": "Tabel {{name}} slettet",
      "table-chart-updated": "Tabel {{name}} redigeret"
    },
    "no-changes-since-then": "Ingen ændringer siden.",
    "no-snapshots-yet": "Ingen sikkerhedskopier endnu",
    "nothing-created-since-then-will-be-deleted": "Intet oprettet siden da bliver slettet.",
    "plus-x-more": "+{{x}} mere",
    "reloading-the-dashboard": "Genindlæser dashboardet…",
    "restore": "Gendan",
    "restore-confirmation-word": "GENDAN",
    "restore-instead": "Gendan i stedet",
    "restore-your-store": "Gendan din butik",
    "restoring-your-store-do-not-close-this-window": "Gendanner din butik. Luk ikke dette vindue.",
    "since-the-x-snapshot": "Siden sikkerhedskopien den {{x}}",
    "snapshots": "Sikkerhedskopier",
    "the-change-was-undone-but-the-page-could-not-refresh": "Ændringen blev fortrudt, men siden kunne ikke opdateres. Genindlæs for at se det.",
    "this-backup-predates-image-protection": "Denne sikkerhedskopi er fra før, vi begyndte at beskytte billeder, så billeder slettet siden da kan ikke hentes tilbage.",
    "this-changes-what-shoppers-see-on-your-product-pages-within-seconds": "Det ændrer inden for sekunder, hvad kunderne ser på dine produktsider.",
    "this-changes-what-shoppers-see-right-away": "Det ændrer med det samme, hvad kunderne ser.",
    "this-puts-your-store-back-to-how-it-was-on-x": "Det sætter din butik tilbage til, som den var den {{x}}.",
    "this-reverses-x-actions-up-to-and-including-y": "Det fortryder {{x}} handlinger, til og med “{{y}}”.",
    "trigger": {
      "daily": "Daglig",
      "install": "Da du installerede Goodchart",
      "manual": "Manuel (support)",
      "migration": "Første sikkerhedskopi",
      "pre-restore": "Før gendannelse",
      "reinstall": "Da du geninstallerede Goodchart"
    },
    "type-x-to-confirm": "Skriv {{x}} for at bekræfte",
    "undid-x": "“{{x}}” fortrudt",
    "undo-a-saved-change": "Fortryd en gemt ændring",
    "undo-to-here": "Fortryd hertil",
    "undo-x-saved-y": "Fortryd “{{x}}”, gemt {{y}}?",
    "unsaved": "Ikke gemt",
    "we-could-not-load-your-history": "Vi kunne ikke indlæse din historik.",
    "we-could-not-load-your-snapshots": "Vi kunne ikke indlæse dine sikkerhedskopier.",
    "we-could-not-restore-your-store": "Vi kunne ikke gendanne din butik.",
    "we-could-not-work-out-what-would-change": "Vi kunne ikke beregne, hvad der ville ændre sig.",
    "we-take-a-snapshot-of-your-current-store-first-so-this-can-be-undone": "Vi tager først en sikkerhedskopi af din nuværende butik, så det kan fortrydes.",
    "we-take-a-snapshot-of-your-store-each-day-it-changes": "Vi tager en sikkerhedskopi af din butik hver dag, den ændrer sig. Din historik vises her, så snart den første er taget.",
    "what-comes-back": "Hvad der kommer tilbage",
    "what-is-lost": "Hvad der går tabt",
    "working-out-what-would-change": "Beregner, hvad der ville ændre sig…",
    "x-assignments": "{{x}} tilknytninger",
    "x-charts": "{{x}} størrelsesguider",
    "x-images-cannot-be-brought-back": "{{x}} billeder kan ikke hentes tilbage — de blev slettet for mere end 37 dage siden.",
    "x-images-could-not-be-recovered": "{{x}} billeder kunne ikke gendannes — de blev slettet for mere end 37 dage siden.",
    "x-items-created-since-then-will-be-deleted": "{{x}} elementer oprettet siden da bliver slettet, heriblandt:",
    "x-items-will-be-recreated": "{{x}} elementer bliver genskabt.",
    "x-no-longer-exists-after-the-undo": "“{{x}}” findes ikke længere efter fortrydelsen.",
    "x-table-charts": "{{x}} tabeller",
    "you-have-unsaved-changes-to-x-undoing-will-discard-them": "Du har ikke-gemte ændringer i “{{x}}”. Fortryder du, kasseres de.",
    "your-store-has-been-restored": "Din butik er blevet gendannet."
  },
  "chart-import": {
    "progress": {
      "stage": {
        "reading-file": "Læser din fil",
        "understanding-table": "Analyserer tabellen",
        "matching-measurements": "Matcher mål",
        "building-chart": "Bygger din størrelsestabel"
      },
      "reconnecting": "Genopretter forbindelsen – vent et øjeblik, dine fremskridt går ikke tabt.",
      "keep-working": "Du kan arbejde videre — vi giver dig besked, når det er klar.",
      "cancel": "Annullér import",
      "cancel-confirm": {
        "title": "Annullér denne import?",
        "message": "Din uploadede fil bliver kasseret, og importen kan ikke genoptages.",
        "keep": "Bliv ved med at vente",
        "discard": "Annullér import"
      },
      "ready": {
        "title": "Størrelsestabel klar til gennemgang",
        "action": "Gennemgå ændringer"
      }
    },
    "failure": {
      "unreadable-file": {
        "message": "Billedet var for sløret eller mørkt til, at vi kunne læse det. Et skarpere, godt belyst billede virker bedst."
      },
      "no-table-found": {
        "message": "Vi kunne ikke finde en størrelsestabel i denne fil."
      },
      "unsupported-layout": {
        "message": "Vi kan endnu ikke læse layoutet i denne tabel."
      },
      "model-timeout": {
        "message": "Det tog for lang tid – det er som regel et midlertidigt problem."
      },
      "internal": {
        "message": "Noget gik galt hos os under importen af din størrelsestabel."
      },
      "action": {
        "retry": "Prøv igen",
        "try-another-photo": "Prøv et andet billede",
        "try-another-file": "Prøv en anden fil",
        "other-methods": "Andre metoder"
      }
    },
    "diff-review": {
      "title": "Gennemgå ændringer",
      "subtitle": "Fjern markeringen fra det, du ikke vil anvende på denne størrelsestabel.",
      "load-error": "Vi kunne ikke indlæse ændringerne for denne import.",
      "no-changes": "Ingen mål er ændret.",
      "grid": {
        "variant": "Størrelse",
        "dimension": "Mål",
        "old-value": "Nuværende",
        "new-value": "Ny"
      },
      "unmatched-variants": "Størrelser i filen, der ikke matcher denne størrelsestabel:",
      "unmapped-dimensions": "Kolonner, vi ikke kunne matche med et mål:",
      "apply": {
        "button": "Anvend ændringer ({{count}})",
        "success": "Størrelsestabel opdateret ({{count}} ændringer anvendt)",
        "generic-error": "Vi kunne ikke anvende disse ændringer. Prøv igen."
      },
      "cancel": {
        "button": "Annullér import"
      }
    },
    "review": {
      "cancel-confirm": {
        "title": "Annullér denne import?",
        "message": "Din uploadede fil og dine ændringer bliver kasseret. Importen kan ikke genoptages.",
        "keep": "Fortsæt gennemgangen",
        "discard": "Annullér import"
      }
    },
    "page": {
      "title": "Importér mål",
      "empty": {
        "title": "Der kører ingen import for denne størrelsestabel",
        "message": "Upload et regneark eller et foto af en størrelsestabel for at opdatere målene i denne tabel."
      }
    },
    "upgrade": {
      "title": "Importér mål med AI",
      "description": "Upload et regneark eller et foto af en størrelsestabel, så udfylder vi målene i denne tabel for dig. AI-import af mål er ikke inkluderet i din nuværende plan. Opgradér for at bruge den.",
      "upgrade-plan": "Opgradér plan",
      "explore-plans": "Udforsk planer",
      "failed-fetch-plans": "Planerne kunne ikke indlæses. Prøv igen.",
      "image-alt": "Illustration af størrelsestabel"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday",
      "chip": "Black Friday-pris",
      "popup": {
        "eyebrow": "Black Friday · Cyber Monday",
        "headline": "Op til {{percent}} % rabat",
        "subheadline": "på Goodchart-planer",
        "body": "Gør dine størrelsesguides klar til årets travleste uge. Tydelige størrelser betyder færre \"passer den?\"-spørgsmål og færre returneringer.",
        "feature-recommender": "AI-størrelsesanbefaling, der foreslår hver kundes størrelse",
        "feature-import": "AI-import, der gør en fil eller et billede til en størrelsesguide",
        "feature-analytics": "Analyser af, hvordan kunderne bruger dine størrelsesguides",
        "cta": "Se tilbuddene",
        "later": "Måske senere"
      },
      "show-offer": "Vis Black Friday-tilbuddet"
    },
    "every-plan": "{{percent}} % rabat på alle planer",
    "up-to": "Op til {{percent}} % rabat",
    "switch-to": "Skift til ${{price}}/{{interval}}",
    "switch-from": "Du har {{name}} til ${{price}}/{{interval}}. Samme funktioner, {{percent}} % billigere.",
    "switch-note-monthly": "Shopify beder dig godkende den nye pris og krediterer resten af denne måned.",
    "switch-note-annual": "Shopify beder dig godkende den nye pris, som gælder fra din fornyelse den {{date}}.",
    "switch-note-annual-undated": "Shopify beder dig godkende den nye pris, som gælder fra din næste fornyelse."
  },
  "agent-chat": {
    "open": "Åbn supportchat",
    "close": "Luk supportchat",
    "expand": "Forstør chatten",
    "collapse": "Formindsk chatten",
    "title": "Goodchart-support",
    "history": "Samtaler",
    "back": "Tilbage til samtalen",
    "new": "Ny samtale",
    "placeholder": "Stil et spørgsmål om Goodchart",
    "send": "Send",
    "welcome": "Hej! Spørg mig om alt om Goodchart: opsætning af størrelsestabeller, størrelsesguiden i din butik eller dit abonnement.",
    "history-empty": "Ingen samtaler endnu.",
    "unread": "Nyt svar",
    "you": "Dig",
    "merchant": "Forhandler",
    "assistant": "Goodchart-assistent",
    "team": "Goodchart-teamet",
    "typing": "Skriver…",
    "used-articles": "Besvaret ud fra hjælpeartiklerne",
    "retry": "Prøv igen",
    "activity": {
      "articles": "Læser hjælpeartiklerne…",
      "store": "Kigger på din butik…",
      "code": "Tjekker, hvordan Goodchart fungerer…",
      "team": "Sender det videre til Goodchart-teamet…"
    },
    "error": {
      "rate-limited": "Du sender beskeder hurtigt. Prøv igen om {{seconds}} sekunder. Hvis du har brug for Goodchart-teamet, så bed mig om dem, når du kan sende igen.",
      "daily-cap": "Du har nået dagens grænse for beskeder. Prøv igen i morgen, og bed mig om Goodchart-teamet, hvis du stadig har brug for dem.",
      "disabled": "Supportassistenten er ikke tilgængelig lige nu.",
      "reply-failed": "Svaret kom ikke igennem.",
      "unknown": "Noget gik galt."
    },
    "placeholder-team": "Tilføj detaljer til Goodchart-teamet",
    "unavailable": "Supportassistenten er ikke tilgængelig lige nu, så den kan ikke tage nye spørgsmål. Samtaler, som Goodchart-teamet allerede har, forbliver åbne i din historik.",
    "waiting": {
      "title": "Venter på Goodchart-teamet.",
      "body": "De svarer her, og du får en notifikation. Du kan tilføje detaljer i mellemtiden."
    },
    "starters": {
      "create-chart": "Hvordan opretter jeg en størrelsestabel?",
      "no-chart": "Hvilke af mine produkter har ingen størrelsestabel?",
      "not-showing": "Hvorfor vises min størrelsestabel ikke i min butik?",
      "charts-left": "Hvor mange flere tabeller kan jeg udgive?"
    },
    "feedback": {
      "helpful": "Nyttigt",
      "not-helpful": "Ikke nyttigt",
      "thanks": "Tak for din feedback.",
      "comment-placeholder": "Hvad var forkert eller manglede? (valgfrit)",
      "send": "Send",
      "skip": "Spring over",
      "rated-up": "Vurderet nyttigt",
      "rated-down": "Vurderet ikke nyttigt"
    }
  }
}
